import * as React from 'react';
import * as styles from './styles.css';

import { UIText2 } from '@cian/ui-kit/typography';

import { ISuggestion } from '../../../../types/fio';

export interface ISuggestProps {
  suggest: ISuggestion[];
  suggestRef: React.LegacyRef<HTMLDivElement>;
  handleClickItem(value: string): void;
}

export function Suggest({ suggest, suggestRef, handleClickItem }: ISuggestProps) {
  return (
    <div ref={suggestRef} className={styles['fio-suggest']}>
      {suggest.map(item => {
        return (
          <div key={item.value} className={styles['fio-item']} onClick={() => handleClickItem(item.value)}>
            <UIText2>{item.value}</UIText2>
          </div>
        );
      })}
    </div>
  );
}
